import { Component, Input, OnInit, ViewEncapsulation } from "@angular/core";
import { ProgressBar } from "./model/progress-bar";
import { CommonModule } from "@angular/common";

@Component({
  selector: "rfc-progress-bar",
  templateUrl: "./progress-bar.component.html",
  styleUrls: ["./progress-bar.component.scss"],
  standalone: true,
  imports: [
    CommonModule
  ]
})
export class ProgressBarComponent {
  @Input() value: ProgressBar;

  constructor() {}

  getProgressStyle() {
    if (this.value) {
      let percetage;
      if (this.value.percentage) {
        percetage = this.value.percentage <= 100 ? this.value.percentage : 100;
      } else {
        percetage = 0;
      }
      return {
        width: percetage + "%",
        backgroundColor: this.value.color,
      };
    }
  }
}
